import { getIdOrLabelFromCategory } from '@modules/common/utils';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { CompareReportDataPoint } from '@modules/quantify/store/types';

export const useGetCompareChartData = (): CompareReportDataPoint[] => {
  const chartDataPoints = useQuantifyStore(
    ({ reportData }) => reportData?.compare.chartDataPoints,
  );

  if (!chartDataPoints?.length) {
    return [];
  }

  return chartDataPoints.map((dataPoint) => ({
    ...dataPoint,
    id: getIdOrLabelFromCategory({
      key: dataPoint.id,
      category: dataPoint.category,
    }),
    label: getIdOrLabelFromCategory({
      key: dataPoint.label,
      category: dataPoint.category,
    }),
  }));
};
